(function ($) {
    $(function () {
        $("#tool-home").click(function () {
            window.location = "http://www.dustars-game.com";
        });

        $("#tool-up").click(function () {
            $('html,body').animate({
                scrollTop: 0
            }, 1000, "swing", function () {

            });
        });

        var isShownView = true;
        $("#tool-view,.tool-view").each(function () {
            $(this).click(function () {
                var hideElem = $('.content *,.screen .pattern,.navbar *,.navbar-background,.screen .shadow, [class$=-blur],nav');
                if (isShownView) {
                    hideElem.stop().animate({ opacity: 0 }, 1000);
                    $(".page-toolbox").stop().animate({ opacity: 0.5 }, 1000);
                    isShownView = false;
                } else {
                    hideElem.stop().animate({ opacity: 1 }, 1000);
                    $(".page-toolbox").stop().animate({ opacity: 1.0 }, 1000);
                    isShownView = true;
                }
            });
        });
    });
    
})(jQuery);